<template>
  <app-page-container title="گزارش ورود و خروج کاربران">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2 mt-3" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mr-n6 mt-6" v-if="isSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="mt-3">
        <v-btn @click="
          exportToExcel(tableHeader, tableItems, 'text', `users_login_logout_report_page_${page}`)
          " fab dark small color="darkColor" elevation="0">
          <v-icon dark>mdi-file-excel mdi-18px</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="card-width body-card pa-0">
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table fixed-header hide-default-header :headers="tableHeader" :items="tableItems"
                      :page.sync="page" :items-per-page="tableItems.length" height="69vh" :search="searchTitle"
                      :hide-default-footer="true" multi-sort class="elevation-0 tt">
                      <template v-slot:header="props">
                        <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                          @group="props.on.group" />
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-0">
          <pagination-component ref="pagination">
            <div slot="action">
              <v-card elevation="0">
                <v-pagination class="mt-8" circle v-model="page" color="lightColor" :length="totalPages"
                  :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                  @next="next()" @previous="previous()" @input="input()"></v-pagination>
              </v-card>
            </div>
          </pagination-component>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
      <section>
        <v-dialog width="450" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-magnify</v-icon>
                  <span class="modal-title-text mr-2">جستجو</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete :items="allUsers" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="fullName" item-value="id" label="کاربر"
                    v-model="searchUserId" autocomplete="off" prepend-inner-icon="mdi-account mdi-18px"
                    style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense
                    clearable autocomplete="off" @click:clear="clearDateTime('searchFromDate')"
                    clear-icon="mdi-close-circle-outline" v-model="tempSearchFromDate"
                    @focus="showSearchFromDate = true" @click="showSearchFromDate = true" label="از تاریخ"
                    prepend-inner-icon="mdi-calendar-range mdi-18px">
                    <template slot="append">
                      <v-icon @click="showSearchFromDate = true" class="calender-background ml-n3 mt-n2" color="white">
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker :show="showSearchFromDate" simple v-model="searchFromDate" type="datetime" @open="onOpen"
                    @change="dateTimeChange('searchFromDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                    display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                    @close="showSearchFromDate = false" />
                </v-col>
                <v-col cols="12">
                  <v-text-field type="text" outlined id="user-arriveToLocationTime" ref="arriveToLocationTime" dense
                    autocomplete="off" clearable @click:clear="clearDateTime('searchToDate')"
                    clear-icon="mdi-close-circle-outline" v-model="tempSearchToDate" @focus="showSearchToDate = true"
                    @click="showSearchToDate = true" label="تا تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                    <template slot="append">
                      <v-icon @click="showSearchToDate = true" class="calender-background ml-n3 mt-n2" color="white">
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker :show="showSearchToDate" simple type="datetime" @open="onOpen" v-model="searchToDate"
                    @change="dateTimeChange('searchToDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                    display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#arriveToLocationTime-arriveToLocationTime"
                    @close="showSearchToDate = false" />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';

import AlertComponent from '@/components/AlertComponent.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import ExcelHelper from '@/Helpers/Excel.generator.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import ReportMixin from '@/Mixins/Report/ReportMixin.js';
import QcUsersLoginLogoutReportHelper from '@/Helpers/Report/QC/QcUsersLoginLogoutReportHelper.js';
import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
export default {
  name: 'qcUsersLoginLogoutReport',
  title: 'گزارش ورود و خروج کاربران ',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    PaginationComponent,
    AppPageContainer,
    AppGroupTableHeader,
  },
  mixins: [
    pagination,
    ShearedMixin,
    ReportMixin,
    QcUsersLoginLogoutReportHelper,
    snackBar,
    ShearedHelper,
    UserMixin,
    ExcelHelper,
  ],
  created() {
    this.$root.$refs.QcUsersLoginLogoutReport = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.setPreTimes();
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
      this.getAllUsersFunction();
    },
    previous: function () {
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {},
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
